import { render, staticRenderFns } from "./CardVS.vue?vue&type=template&id=2e7fa9db"
import script from "./CardVS.vue?vue&type=script&lang=js"
export * from "./CardVS.vue?vue&type=script&lang=js"
import style0 from "./CardVS.vue?vue&type=style&index=0&id=2e7fa9db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports